var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./AwardsCommonWinnersList.jinja');
require('./AwardsCommonWinnersList.less');

module.exports = Base.extend({

    template: template,

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.js
// module id = 62
// module chunks = 0